import { Injectable, inject } from '@angular/core';
import { RightBridgeApiService } from './right-bridge-api.service';
import { SessionStorageService } from './session-storage.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private rbs = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);

  private permList = this.ss.get('rights');
  private permSubject = new BehaviorSubject<any>(this.permList);
  public permissions = this.permSubject
    .asObservable()
    .pipe(distinctUntilChanged());
}
